import React from "react";

const Button = ({
  primary,
  success,
  info,
  warning,
  danger,
  rounded,
  clean,
  onClick,
  large,
  small,
  xs,
  label = "Default Button",
  style,
  disabled,
  className = ""
}) => {
  let _classes = ["btn"];
  if (primary) {
    _classes.push("btn-primary");
  }
  if (success) {
    _classes.push("btn-success");
  }
  if (info) {
    _classes.push("btn-info");
  }
  if (warning) {
    _classes.push("btn-warning");
  }
  if (danger) {
    _classes.push("btn-danger");
  }
  if (!primary && !success && !info && !danger) {
    _classes.push("btn-default");
  }
  if (rounded) {
    _classes.push("btn-rounded");
  }
  if (clean) {
    _classes.push("btn-clean");
  }
  if (large) {
    _classes.push("btn-lg");
  }
  if (small) {
    _classes.push("btn-sm");
  }
  if (xs) {
    _classes.push("btn-xs");
  }
  return (
    <button
      className={_classes.concat(className.split(",")).join(" ")}
      onClick={onClick}
      style={style}
      disabled={disabled}
    >
      {label}
    </button>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/_components/UI/Button/index.js